import { render, staticRenderFns } from "./BillingPeriods.vue?vue&type=template&id=388859d6"
import script from "./BillingPeriods.vue?vue&type=script&lang=js"
export * from "./BillingPeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports